import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=b6e7ee52&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=b6e7ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../Com.GamerSky.App.GameTools/GamerSky.recordInquiry/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e7ee52",
  null
  
)

export default component.exports